import { Nullable } from "../models/Nullable"

export function isNumber(number?: Nullable<number>): number is number {
    return number !== null && number !== undefined && !isNaN(number)
}
